function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Attach");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.73
}, React.createElement("g", {
  id: "icon-attach",
  transform: "translate(0.000000, 1.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(0.000000, -1.000000)"
}, React.createElement("path", {
  d: "M9.51827542,0 L1.34086868,8.17739944 C-0.446959333,9.96523155 -0.446953122,12.8712056 1.34086868,14.6590377 C3.12869679,16.4468698 6.03467743,16.447105 7.82249918,14.6590377 L15.2292101,7.25231477 C16.4998116,5.9817171 16.4995749,3.90847452 15.2292101,2.63787686 C13.9586087,1.36725567 11.8853576,1.3672792 10.6147565,2.63787686 L3.05487468,10.1977377 C2.30146277,10.951148 2.30001255,12.191612 3.05363005,12.9450223 C3.80704196,13.6984326 5.04872079,13.6981973 5.80212681,12.9450223 L11.6431288,7.1040227 L10.7630288,6.22391493 L4.92202046,12.0649145 C4.64101664,12.3459261 4.21594745,12.3461614 3.93494998,12.0649145 C3.65393981,11.7839265 3.65417622,11.3588571 3.93494998,11.0778455 L11.4948252,3.5179611 C12.2930246,2.71976212 13.5508794,2.71976212 14.3490788,3.5179611 C15.1472846,4.31616008 15.1475211,5.57400802 14.3490788,6.37223052 L6.94236813,13.7789299 C5.62695446,15.0943634 3.53636354,15.0941281 2.22093764,13.7789299 C0.905517615,12.46352 0.905517615,10.3729171 2.22093764,9.05750721 L10.3983444,0.880107767 L9.51827542,0 Z",
  id: "Path"
}))));

const SvgAttach = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgAttach, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/attach.b7adf72f.svg";
export { ForwardRef as ReactComponent };